import React, { useState, useContext, useEffect } from 'react';
import { Box, Grid, Paper, Card, Typography, TextField, MenuItem, Checkbox, FormControl, ListItemText, Select, FormGroup, FormControlLabel, Radio } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import ApiService from "../../functions/apiService";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';

const SellHoliday = ({ userSellHolidayList }) => {
  const [subTypeList, setSubTypeList] = useState([])
  const [subType, setSubType] = useState('');
  const [total, setTotal] = useState('')
  const [note, setNote] = useState('')
  const [dateValue, setDateValue] = useState(dayjs().format('YYYY-MM-DD'));
  const { user } = useContext(AuthContext);

  useEffect(() => {
    ApiService.get('/getSoldSubTypes').then(({ data }) => {
      setSubTypeList(data?.data)
    }).catch((error) => {
      toast.error(error)
    })
  }, [])

  const handleDateChange = (newValue) => {
    setDateValue(dayjs(newValue).format('YYYY-MM-DD'));
  };

  const handleSubmit = () => {
    const body = {
      "Date": dateValue,
      "Type": 'SOLD',
      "Sub_Type": subType,
      "Total": total,
      "Note": note,
    }
    ApiService.post('/submitAccrualRequest', body).then((data) => {
      toast.success('Request Send Successfully')
      userSellHolidayList()
      setDateValue(new Date())
      setSubType('')
      setTotal('')
      setNote('')
    }).catch((error) => {
      toast.error(error?.data?.message)
    })
  }

  return (
    <>
      <Card className="p-4 shadow" style={{ marginTop: "1rem" }}>
        <div className='mb-4'>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h6 className='fs-5 fw-600 my-2'>Sell PTO Request</h6>
            </Grid>
          </Grid>
        </div>
        <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker', 'DatePicker']}>
                  <DatePicker
                    value={dayjs(dateValue)}
                    onChange={handleDateChange}
                    sx={{ width: '100%' }}
                    label="Date"
                    minDate={dayjs()}
                    slotProps={{
                      textField: {
                        sx: {
                          width: "100%",
                          '& .MuiOutlinedInput-root': {
                            height: "56px",
                            width: '100%',
                          },
                        }
                      }
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3} className='mt-2'>
              <TextField
                select
                fullWidth
                value={subType}
                label="Absent Code"
                onChange={e => setSubType(e.target.value)}
              >
                <MenuItem value="" disabled>
                  Please Select
                </MenuItem>
                {subTypeList.map((type) => (
                  <MenuItem value={type.SO_Value}>
                    {type.SO_Desc}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3} className='mt-2'>
              <TextField
                fullWidth
                placeholder="Total"
                label="Total"
                type='number'
                inputProps={{ step: "any", min: 0 }}
                value={total}
                onKeyDown={(e) => {
                  if (e.key === '-') {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === '') {
                    setTotal('');
                    return;
                  }

                  const num = parseFloat(value);

                  if (num > 0) {
                    setTotal(value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={3} className='mt-2'>
              <TextField
                fullWidth
                placeholder="Note"
                label="Note"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </Grid>
          </Grid>
          <ButtonTheme disabled={!(subType && total && dateValue)} onClick={handleSubmit}
            variant="filled" color='primary' className='px-5 mt-4'>
            Submit
          </ButtonTheme>
        </Box >
      </Card>
    </>
  )
}

export default SellHoliday